"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon24Regular = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon24Regular = forwardRef_1.forwardRef('ArrowCDownIcon24Regular', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M20.617 7.881a.875.875 0 0 1 0 1.238l-6.407 6.407a3.125 3.125 0 0 1-4.42 0L3.384 9.119A.875.875 0 1 1 4.62 7.88l6.407 6.407a1.375 1.375 0 0 0 1.944 0l6.407-6.407a.875.875 0 0 1 1.238 0Z" })));
});
